import React, { useCallback, useEffect, useState, useRef } from 'react';
import './NewMember.scss';
import GlobalParams from '../../helpers/GlobalParams.js';
import Form, { Item, GroupItem, Label, ButtonItem, ButtonOptions, RequiredRule, CustomRule } from 'devextreme-react/form';
import { DataGrid, Column } from 'devextreme-react/data-grid';
import { Button, Lookup, TextBox, LoadPanel, DateBox, NumberBox, CheckBox, Popup, FileUploader } from 'devextreme-react';
import ApiHelper from '../../helpers/ApiHelper.js';
import LabelTemplate from '../../labels/LabelTemplate.js';
import ApiPostHelper from '../../helpers/ApiPostHelper.js';
import notify from 'devextreme/ui/notify';
import axios from 'axios';
import MemberDependant from '../MemberDependant/MemberDependant.js';


var default_form =
{
  portal_user_id: GlobalParams.ContactPersonId,
  MemberEmail: '',
  scheme_id: null,//GlobalParams.defaultSchemeId,
  endorsement_type: 2,
  requested_change: '',
  IdType: 'ID No.',
  MemberName: '',
  MemberNo: '',
  DateOfBirth: null,
  MemberAge: null,
  MemberSalary: null,
  IdNumber: '',
  effective_date: new Date(),
  HasDependants: false,
  with_categories: null,
  premium_rate: null
};

const isDateInRange = (date_from, date_to, check_date) => {
  return check_date >= date_from && check_date <= date_to;
}
//
const validationRules = {
  MemberName: [{ type: 'required', message: 'Name is required.' }],
  MemberNo: [{ type: 'required', message: 'Staff No is required.' }],
  DateOfBirth: [{ type: 'required', message: 'Date of Birth is required.' }],
  MemberAge: [{ type: 'required', message: 'Member Age is required.' }],
  MemberSalary: [{ type: 'required', message: 'Salary is required.' }],
  IdNumber: [{ type: 'required', message: 'ID Number is required.' }],
  effective_date: [{ type: 'required', message: 'Joining Date is required.' }],
  requested_change: [{ type: 'required', message: 'Narration is required' }],
};

const dataGridOptions = {
  allowUpdating: false,
  mode: 'form',
  allowAdding: false,
  allowDeleting: true,
};

///////////grid options///////

var searchPanelOptions = {
  visible: false,
  width: 250
};

var relationshipStoreOptions = {
  dataSource: GlobalParams.RelationshipStore, valueExpr: 'id', displayExpr: 'name'
};
var groupOptions = {
  contextMenuEnabled: true, groupPanel: { visible: true },
};
var scrollingOptions = { mode: 'standard' };
var pagingOptions = { enabled: false };
/////////end of grid options///
const IDNumberEditorOptions = { readOnly: true, maskRules: { X: /[02-9]/ } };

// eslint-disable-next-line import/no-anonymous-default-export
function NewMember({ onClosePopup, schemeStore }) {

  //console.log(schemeStore);

  var filesData = [];
  const [memberStore, setMemberStore] = useState(default_form);
  const [schemeCategoriesStore, setSchemeCategoriesStore] = useState([]);
  const [fixed_benefit, set_fixed_benefit] = useState(false);
  const [with_categories, set_with_categories] = useState(false);
  const [UseMemberRate, setUseMemberRate] = useState(false);
  const [dependantsData, setDependantsStore] = useState([]);
  const [vsDependantsGrid, setvsDependantsGrid] = useState(false);
  const [popupDpVisible, setPopupDpVisible] = useState(false);
  //const [schemeStore, setSchemeStore] = useState(GlobalParams.schemeStore.filter(scheme => (scheme.StatusCode === "001")));
  //////////get members/////
  const [isLoading, setIsLoading] = useState(false);
  const fetchData = async (scheme_id, name) => {
    try {
      const result = await ApiHelper.fetchData(
        GlobalParams.ApiUrlPrefix + "search-members?scheme_id=" + scheme_id + "&name=" + name,
        GlobalParams.bearerToken
      );
      //console.log(result.data);
      //setData(result.data);
    } catch (error) {
      // Handle error, e.g., show an error message
      console.log(error);
    } finally {
      // Set isLoading to false after renderPdfViewer completes
      setIsLoading(false);
    }
  };
  ///////////insert members/////////
  const postData = async (postData, dependants_Data) => {
    try {
      var post_data = postData;
      post_data.portal_user_id = GlobalParams.ContactPersonId;
      if (post_data.MemberSalary !== undefined && post_data.MemberSalary !== null) {
        post_data.MemberSalary = post_data.MemberSalary.replace(/[,!]/g, '');
      }
      let tmp_filesData = filesData.length > 0 ? filesData : [];

      if (post_data.HasDependants === true) {
        post_data.HasDependants = 1;
      } else {
        post_data.HasDependants = 0;
      }
      let tmp_dependantsData = dependants_Data.length > 0 ? dependants_Data : [];

      console.log(tmp_dependantsData);


      //concertinate...
      // let combinedHashmap = tmp_dependantsData.length > 0 ? tmp_dependantsData.reduce((acc, obj, index) => {
      //   // Assuming the formdata is the key 'key' in each object
      //   Object.keys(obj).forEach(key => {
      //     acc[`dependants[${index}][${key}]`] = obj[key];
      //   });
      //   return acc;
      // }, { ...post_data }) : post_data;

      let combinedHashmap = tmp_dependantsData.length > 0 ?
        tmp_dependantsData.reduce((acc, obj, index) => {
          // Iterate over each key in the current dependent's object
          Object.keys(obj).forEach(key => {
            // Use a computed property name to create the combined key
            acc[`dependants[${index}][${key}]`] = obj[key];
          });
          // Return the accumulator for the next iteration
          return acc;
        }, { ...post_data })
        :
        { ...post_data }; 
        // Ensure to create a new object for post_data when there are no dependents

      console.log(combinedHashmap);

      if (filesData.length > 0) {
        combinedHashmap = tmp_filesData.length > 0 ? tmp_filesData.reduce((acc, obj, index) => {
          // Assuming the formdata is the key 'key' in each object
          Object.keys(obj).forEach(key => {
            acc[`files[${key}]`] = obj[key];
          });
          return acc;
        }, { ...post_data }) : { ...post_data };
      }
      console.log(combinedHashmap);

      const result = await axios.post(
        GlobalParams.ApiUrlPrefix + "request-endorsements",
        combinedHashmap,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken, // Include bearer token in the Authorization header
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      //console.log(result.status);
      setIsLoading(false);
      clear_form();
      notify("Member successfully Added", 'success', 5000);
      //console.log("request id: " + result.data.data.request_id);
      postAutomate(result.data.data.request_id, post_data.scheme_id);
      onClosePopup();
    } catch (error) {
      // Handle error, e.g., show an error message
      setIsLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  };

  const postSchemeBalance = async (scheme_id) => {
    try {

      let post_data = {
        'scheme_id': scheme_id
      };
      const result = await axios.post(
        GlobalParams.ApiUrlPrefix + "recalculate-scheme-balance",
        post_data,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken, // Include bearer token in the Authorization header
            'Content-Type': 'multipart/form-data'
          }
        }
      );
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  };

  const postDebits = async (scheme_id) => {
    try {

      let post_data = {
        'scheme_id': scheme_id
      };
      const result = await axios.post(
        GlobalParams.ApiUrlPrefix + "post-debits-to-gl",
        post_data,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken, // Include bearer token in the Authorization header
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      postSchemeBalance(scheme_id);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  };

  const postAutomate = async (request_id, scheme_id) => {
    try {

      let post_data = {
        'request_id': request_id
      };
      //console.log(post_data);
      const result = await axios.post(
        GlobalParams.ApiUrlPrefix + "get-endorsements-processing-results",
        post_data,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken, // Include bearer token in the Authorization header
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      postDebits(scheme_id);
      //console.log(result.data.request_id);
      //console.log("Automation Request finished");
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  };

  //clear the form....
  const clear_form = () => {
    setMemberStore((state) => {
      return ({ ...state, scheme_id: null })
    });
    setDependantsStore([]);
    setMemberStore(default_form);
  }

  const fetchCategories = async (schemeId) => {
    try {
      setIsLoading(true);
      let url = GlobalParams.ApiUrlPrefix + 'scheme-categories?scheme_id=' + schemeId
      const result = await axios.get(
        url,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken
          }
        }
      );

      setIsLoading(false);
      setSchemeCategoriesStore(result.data.data);
      //console.log(result.status);
      console.log(result.data.data);
    } catch (error) {
      // Handle error, e.g., show an error message
      //setLoading(false);
      setIsLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  };


  //////new member form//////





  const doSave = useCallback(async (e) => {
    e.preventDefault();



    if (memberStore.HasDependants && (dependantsData === null || dependantsData === undefined || dependantsData.length === 0)) {
      notify('Kindly add Dependants', 'error', 5000);
      return;
    }
    //TODO perform the search here
    //console.log('Search clicked. Scheme:', memberStore.scheme_id);
    setIsLoading(true);
    //fetchData(searchStore.scheme_id, searchStore.name);
    postData(memberStore, dependantsData);
    // Close the pop-up after the search is performed
  }, [memberStore, dependantsData]);
  /////end of search form///
  const emptyItemConfig = {
    colSpan: 3,
    itemType: 'empty',
  };

  const calculateAge = (birthDate) => {
    const currentDate = new Date();
    const birthDateObj = new Date(birthDate);

    let age = currentDate.getFullYear() - birthDateObj.getFullYear();

    // Check if the birthday has occurred for this year
    if (currentDate.getMonth() < birthDateObj.getMonth() ||
      (currentDate.getMonth() === birthDateObj.getMonth() && currentDate.getDate() < birthDateObj.getDate())) {
      age--;
    }

    return age;
  };


  const hideDpPopup = () => {
    setPopupDpVisible(false);
  };

  const updateSchemeId = e => {
    if (e.value !== undefined && e.value !== null && e.value !== '') {

      //TODO - determine if its with categoy or member_rate
      var index = schemeStore.findIndex(function (item) {
        return item.schemeID === e.value;
      });
      console.log(index);
      setUseMemberRate(false);
      set_with_categories(false);
      set_fixed_benefit(false);

      if (index > -1) {
        console.log(schemeStore[index]['with_categories']);
        if (schemeStore[index]['UseMemberRate'] === "1") {
          setUseMemberRate(true);
        }
        if (schemeStore[index]['with_categories'] === "1") {
          set_with_categories(true);
          fetchCategories(e.value);
        }
        if (schemeStore[index]['fixed_benefit'] === "1") {
          set_fixed_benefit(true);
        }
      }


      ////console.log(e.value);
      setMemberStore(prevState => ({
        ...prevState,
        scheme_id: e.value
      }));
    }
  };



  return (
    <div >
      {isLoading && <LoadPanel visible={true} />}

      {/*Add Dependant pop up */}
      <div>
        <Popup
          hideOnOutsideClick={false}
          visible={popupDpVisible}
          onHiding={hideDpPopup}
          title="ADD NEW DEPENDANT"
          position={{ my: 'top', at: 'top', of: window }}
          height={300}
        >
          <div>
            <MemberDependant onClosePopup={(e) => {
              setDependantsStore((prevData) => {
                // Ensure prevData is initialized as an array
                const tmp_dependant = Array.isArray(prevData) ? [...prevData, e] : [e];
                //console.log(tmp_dependant);
                return tmp_dependant;
              });
              hideDpPopup();
            }} SchemeID={memberStore.scheme_id} />
          </div>
        </Popup>
      </div>

      <br />
      <form onSubmit={doSave}>
        <Form
          // onContentReady={(e) => {
          //   console.log("am filtering the categories ");
          //   if (schemeStore.length === 1) {
          //     //fetch the categories
          //     setUseMemberRate(false);
          //     set_with_categories(false);
          //     set_fixed_benefit(false);

          //     console.log(schemeStore[0]['with_categories']);
          //     if (schemeStore[0]['UseMemberRate'] === "1") {
          //       setUseMemberRate(true);
          //     }
          //     if (schemeStore[0]['with_categories'] === "1") {
          //       set_with_categories(true);
          //       fetchCategories(schemeStore[0]['schemeID']);
          //     }
          //     if (schemeStore[0]['fixed_benefit'] === "1") {
          //       set_fixed_benefit(true);
          //     }
          //   }

          // }}
          formData={memberStore}>
          <GroupItem colCount={3} caption="">

            <Item
              colSpan={3}
              dataField="scheme_id"
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: schemeStore,
                  displayExpr: "PolicyCompany",
                  valueExpr: "schemeID",
                  searchEnabled: false,
                  onValueChanged: (e) => updateSchemeId(e),
                  value: memberStore.scheme_id
                }
              }
            >
              <RequiredRule message="Policy No / Scheme is required" />
              <Label text='Policy No / Scheme' />
            </Item>

            <Item
              colSpan={3}
              dataField="category_code"
              visible={with_categories}
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: schemeCategoriesStore,
                  displayExpr: "description",
                  valueExpr: "CategoryCode",
                  searchEnabled: false
                }
              }
            >
              {with_categories && <RequiredRule message="Scheme Category is required" />}
              <Label text='Scheme Category' />
            </Item>

            <Item
              colSpan={2}
              dataField="MemberName"
              editorType="dxTextBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      ////console.log(e.value);
                      setMemberStore((state) => {
                        return ({ ...state, MemberName: e.value })
                      });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Member Name is required" />
              <Label text='Name' />
            </Item>

            <Item
              dataField="MemberNo"
              editorType="dxTextBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //console.log(e.value);
                      setMemberStore((state) => {
                        return ({ ...state, MemberNo: e.value })
                      });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Member No is required" />
              <Label text='Staff Number' />
            </Item>

            {/*MemberEmail */}
            {/* <Item
              colSpan={2}
              dataField="MemberEmail"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      setMemberStore((state) => {
                        return ({ ...state, MemberEmail: e.value })
                      });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Email is required" />
              <Label text='Email' />
            </Item> */}


            <Item
              dataField="DateOfBirth"
              editorType="dxDateBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //console.log(e.value);
                      const age = calculateAge(e.value);

                      var selectedDate = e.value;
                      var currentDate = new Date();

                      // Compare the selected date with the current date
                      if (selectedDate > currentDate) {
                        notify('Future Date of Birth is not allowed', 'error', 5000);
                        e.component.option("value", null); // Reset the value
                        return;
                      }

                      if (age < 18 || age > 80) {
                        // Clear the value if age is not within the range
                        e.component.option('value', null);
                        // You can also provide feedback to the user that the value is invalid
                        notify('Date of Birth must be between 18 and 80 years old', 'error', 5000);
                      } else {
                        //console.log(e.value);

                        setMemberStore((state) => {
                          return ({ ...state, DateOfBirth: e.value })
                        });
                        setMemberStore((state) => {
                          return ({ ...state, MemberAge: age })
                        });
                        //setMemberStore(prevData => ({ ...prevData, MemberAge: age }));
                      }
                    }
                  }
                }
              }
            >
              <RequiredRule text="Date of Birth is Required is required" />
              <Label text='Date of Birth' />
            </Item>

            <Item
              dataField="MemberAge"
              editorType="dxNumberBox"
              editorOptions={
                {
                  readOnly: true,
                }
              }
            >
              <RequiredRule message="Age is required" />
              <Label text='Age' />
            </Item>

            <Item
              dataField="IdNumber"
              editorType="dxTextBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //console.log(e.value);
                      setMemberStore((state) => {
                        return ({ ...state, IdNumber: e.value })
                      });
                    }
                  }
                }
              }
            >
              <RequiredRule message="ID Number is required" />
              <Label text='ID / Passport Number' />
            </Item>

            <Item
              dataField="Salary"
              editorType="dxNumberBox"
              visible={!fixed_benefit}
              editorOptions={
                {
                  format: ",##0.###",
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      console.log(e.value)
                      let annual_salo = GlobalParams.formatNumberWithCommas(parseFloat(e.value) * 12);
                      setMemberStore((state) => {
                        return ({ ...state, MemberSalary: annual_salo })
                      });
                    }
                  }
                }
              }
            >
              {!fixed_benefit && <RequiredRule message="Salary is required" />}
              <Label text='Monthly Salary' />
            </Item>

            <Item
              dataField="MemberSalary"
              visible={!fixed_benefit}
              editorType="dxTextBox"
              editorOptions={
                {
                  readOnly: true,
                }
              }
            >
              {!fixed_benefit && <RequiredRule message="Member Salary is required" />}
              <Label text='Annual Salary' />
            </Item>



            <Item
              dataField="effective_date"
              editorType="dxDateBox"
              editorOptions={
                {
                  readOnly: true,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //get the cover periods dates

                      const SchemeDetails = GlobalParams.schemeStore.find(item => item.schemeID === memberStore.scheme_id);

                      // Assign the name to the variable 'ans'
                      const DateFrom = SchemeDetails ? SchemeDetails.DateFrom : null;
                      const End_date = SchemeDetails ? SchemeDetails.End_date : null;

                      if (isDateInRange(new Date(DateFrom), new Date(End_date), new Date(e.value))) {
                        console.log(new Date(e.value));
                        setMemberStore((state) => {
                          return ({ ...state, effective_date: new Date(e.value) })
                        });
                      } 
                      // else {
                      //   // Clear the value if age is not within the range
                      //   e.component.option('value', null);
                      //   // You can also provide feedback to the user that the value is invalid
                      //   notify('Joining Date is Outside the cover period', 'error', 5000);
                      // }
                    }
                  }
                }
              }
            >
              <RequiredRule message="Joining Date is required" />
              <CustomRule
                message="Joining Date is Outside the cover period"
                validationCallback={
                  (e) => {

                    const SchemeDetails = GlobalParams.schemeStore.find(item => item.schemeID === memberStore.scheme_id);

                    // Assign the name to the variable 'ans'
                    const DateFrom = SchemeDetails ? SchemeDetails.DateFrom : null;
                    const End_date = SchemeDetails ? SchemeDetails.End_date : null;
                    return (isDateInRange(new Date(DateFrom), new Date(End_date), new Date(e.value)));
                  }
                }
              />
              <Label text='Joining Date' />
            </Item>

            {/* Add premium_rate & category_code UseMemberRate*/}



            <Item
              dataField="premium_rate"
              editorType="dxNumberBox"
              visible={UseMemberRate}
              editorOptions={
                {
                  format: ",##0.###",
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      console.log(e.value)
                      setMemberStore((state) => {
                        return ({ ...state, premium_rate: e.value })
                      });
                    }
                  }
                }
              }
            >
              {UseMemberRate && <RequiredRule message="Member Premium Rate is required" />}
              <Label text='Member Premium Rate' />
            </Item>


            <Item {...emptyItemConfig} />
            <Item {...emptyItemConfig} />

            <Item
              colSpan={3}
              dataField="requested_change"
              editorType="dxTextArea"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      setMemberStore((state) => {
                        return ({ ...state, requested_change: e.value })
                      });
                    }
                  }
                }
              }
            >
              <RequiredRule message="Narration is required" />
              <Label text='Narration' />
            </Item>



            <Item {...emptyItemConfig} />
            <Item {...emptyItemConfig} />
            <Item
              colSpan={3}
              dataField="HasDependants"
              editorType="dxCheckBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    //console.log(e.value);
                    //if (e.value !== undefined && e.value !== null && e.value !== '') {
                    setMemberStore((state) => {
                      return ({ ...state, HasDependants: e.value })
                    });
                    if (e.value === true) {
                      setvsDependantsGrid(true);
                    } else {
                      setvsDependantsGrid(false);
                    }
                    //}
                  }
                }
              }
            >
              <Label text='Has Dependants' />
            </Item>


            <Item {...emptyItemConfig} />
            <Item {...emptyItemConfig} />

            <ButtonItem
              visible={vsDependantsGrid}
              colSpan={3}
            >
              <ButtonOptions
                type='danger'
                width={180}
                text="Add Dependant"
                icon='plus'
                onClick={
                  () => {
                    if (memberStore.scheme_id !== undefined &&
                      memberStore.scheme_id !== null && memberStore.scheme_id !== '') {
                      setPopupDpVisible(true);
                    } else {
                      notify('Kindly Select Scheme / Policy No', 'error', 5000);
                    }
                  }
                }
              />
            </ButtonItem>

            <Item {...emptyItemConfig} />
            <Item {...emptyItemConfig} />

            <Item colSpan={3}>
              <DataGrid
                visible={vsDependantsGrid} width={'95%'}
                dataSource={dependantsData} wordWrapEnabled={true} columnHidingEnabled={true}
                searchPanel={searchPanelOptions} editing={dataGridOptions}
                allowColumnReordering={true} scrolling={scrollingOptions} paging={pagingOptions}>
                <Column dataField="DependantFullName" caption='Full Names'></Column>
                <Column
                  dataField="DependantDOB"
                  caption='Date Of Birth'
                  dataType="date">
                </Column>
                <Column
                  dataField="RelationshipType"
                  caption='Relationship'
                  lookup={relationshipStoreOptions}
                >
                </Column>
                <Column
                  dataField="DependantJoiningDate"
                  caption='Joining Date'
                  dataType="date">
                </Column>
              </DataGrid>
            </Item>

            <Item {...emptyItemConfig} />
            <Item {...emptyItemConfig} />

            {/* Upload any file */}
            <Item colSpan={3}>
              <div style={{ color: '#2E86C1', fontWeight: 'bold' }}>Add Attachment</div>
              <FileUploader
                multiple={false}
                selectButtonText="Select File"
                uploadMode="useForm"
                onValueChanged={(e) => {
                  let files = e.value;
                  filesData.push({ [1]: files[0] });
                }}
                style={{ borderBottom: '1px solid #000' }}
              />
            </Item>

            <Item {...emptyItemConfig} />
            <Item {...emptyItemConfig} />

            <ButtonItem
              colSpan={3}
            >
              <ButtonOptions type='default' text="SUBMIT" icon='save' useSubmitBehavior={true} />
            </ButtonItem>
          </GroupItem>
        </Form>
      </form>
      <br></br>

    </div>
  );
}

export default NewMember;